import { graphql } from "../gql";

export const drgDeleteClaimCodeMutationDoc = graphql(`
  mutation drgDeleteClaimCode($input: DrgDeleteClaimCodeInput!) {
    drgDeleteClaimCode(input: $input) {
      ...DrgClaimCodeFields
    }
  }
`);
